import {c as createCommonjsModule, g as getDefaultExportFromCjs} from "../../common/_commonjsHelpers-8c19dec8.js";
import {i as interopRequireDefault} from "../../common/interopRequireDefault-d2c9da36.js";
import {_ as _extends_1, o as objectWithoutPropertiesLoose} from "../../common/defaultTheme-ca6a0b43.js";
import React from "react";
import {p as propTypes} from "../../common/index-877ea290.js";
import {r as require$$3} from "../../common/clsx.m-5dc7436b.js";
import {c as core} from "../../common/index-0a000c27.js";
import {u as useThemeProps_1, s as styled_1} from "../../common/useThemeProps-ef190a94.js";
import _jsxRuntime from "react/jsx-runtime";
import "../../common/capitalize-c580b26a.js";
import "../../common/hoist-non-react-statics.cjs-7c8198a1.js";
import "../../common/colorManipulator-ba921df7.js";
import "../../common/useForkRef-edb3fede.js";
import "../../common/emotion-element-99289b21.browser.esm-15d91a3a.js";
import "../../common/useTheme-81ac7d8e.js";
import "../../common/useEventCallback-4c5b62b3.js";
import "../../common/nested-5a43708e.js";
import "../../common/ModalUnstyled-c2fd569c.js";
import "../../common/Portal-3c4bf8a9.js";
import "react-dom";
import "../../common/Popper-131a89f2.js";
var tableContainerClasses_1 = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  exports.getTableContainerUtilityClass = getTableContainerUtilityClass;
  function getTableContainerUtilityClass(slot) {
    return (0, core.generateUtilityClass)("MuiTableContainer", slot);
  }
  const tableContainerClasses = (0, core.generateUtilityClasses)("MuiTableContainer", ["root"]);
  var _default = tableContainerClasses;
  exports.default = _default;
});
var TableContainer_1 = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _extends2 = interopRequireDefault(_extends_1);
  var _objectWithoutPropertiesLoose2 = interopRequireDefault(objectWithoutPropertiesLoose);
  var React$1 = _interopRequireWildcard(React);
  var _propTypes = interopRequireDefault(propTypes);
  var _clsx = interopRequireDefault(require$$3);
  var _useThemeProps = interopRequireDefault(useThemeProps_1);
  var _styled = interopRequireDefault(styled_1);
  const _excluded = ["className", "component"];
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  const useUtilityClasses = (ownerState) => {
    const {
      classes
    } = ownerState;
    const slots = {
      root: ["root"]
    };
    return (0, core.unstable_composeClasses)(slots, tableContainerClasses_1.getTableContainerUtilityClass, classes);
  };
  const TableContainerRoot = (0, _styled.default)("div", {
    name: "MuiTableContainer",
    slot: "Root",
    overridesResolver: (props, styles) => styles.root
  })({
    width: "100%",
    overflowX: "auto"
  });
  const TableContainer2 = /* @__PURE__ */ React$1.forwardRef(function TableContainer3(inProps, ref) {
    const props = (0, _useThemeProps.default)({
      props: inProps,
      name: "MuiTableContainer"
    });
    const {
      className,
      component = "div"
    } = props, other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    const ownerState = (0, _extends2.default)({}, props, {
      component
    });
    const classes = useUtilityClasses(ownerState);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(TableContainerRoot, (0, _extends2.default)({
      ref,
      as: component,
      className: (0, _clsx.default)(classes.root, className),
      ownerState
    }, other));
  });
  var _default = TableContainer2;
  exports.default = _default;
});
var TableContainer = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _exportNames = {
    tableContainerClasses: true
  };
  Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
      return _TableContainer.default;
    }
  });
  Object.defineProperty(exports, "tableContainerClasses", {
    enumerable: true,
    get: function() {
      return _tableContainerClasses.default;
    }
  });
  var _TableContainer = interopRequireDefault(TableContainer_1);
  var _tableContainerClasses = _interopRequireWildcard(tableContainerClasses_1);
  Object.keys(_tableContainerClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule")
      return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key))
      return;
    if (key in exports && exports[key] === _tableContainerClasses[key])
      return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function() {
        return _tableContainerClasses[key];
      }
    });
  });
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
});
var __pika_web_default_export_for_treeshaking__ = /* @__PURE__ */ getDefaultExportFromCjs(TableContainer);
export default __pika_web_default_export_for_treeshaking__;
